import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
interface MultiPeriodAllocationRequest {
  glPeriodId: number;
  amount: number;
  percentage: number;
  isClosed: number;
}

interface MultiPeriodAllocationResponse {
  invoiceId: number;
  success: boolean;
}
const useInvoiceMultiPeriodAllocationUpdateApi = (invoiceId: number) => {
  const call = useCallback(
    async (data?: MultiPeriodAllocationRequest[]) => {
      try {
        const res = await axiosInstance.put<MultiPeriodAllocationResponse>(
          api.getInvoiceMultiPeriodAllocation(Number(invoiceId)),
          {
            periodAllocations: data,
          }
        );
        const success: boolean = res.status === 200 || res.status === 204;
        if (success) {
          return {
            invoiceId,
            success,
          };
        }
        return res.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [invoiceId]
  );
  const { execute, value, isLoading } = useAsync(call, false);
  return {
    updateMultiPeriodAllocation: execute,
    multiPeriodAllocationList: value,
    isMultiPeriodLoading: isLoading,
  };
};
export default useInvoiceMultiPeriodAllocationUpdateApi;
